import{jsx as t}from"react/jsx-runtime";import{NotificationContainer as i}from"@vds-core/notifications";import o from"./Notification.js";const r=function(r){return t(i,Object.assign({},r,{renderNotification:o}))};export{r as default};
